import React from 'react';

import { Box } from '@opendoor/bricks-next';

import type { ICardListProps } from '../../landing-pages-v2/Multicard';
import MulticardCard from './MulticardCard';
import type { IMulticardCardDetails } from './MulticardCard';

import styles from './MulticardList.module.css';

const MulticardList = ({
  cards,
  componentTheme,
  columnNumber,
  isArched,
  isAccordion,
  minHeight,
  cardVerticalAlignment,
}: ICardListProps<IMulticardCardDetails>) => (
  <Box
    tag="ul"
    m="$0"
    p="$0"
    role="list"
    gap="$4"
    className={styles.list}
    style={{ '--column-number': columnNumber } as React.CSSProperties}
  >
    {cards?.map((card, idx) => (
      <MulticardCard
        card={card}
        id={`${idx}`}
        key={idx}
        componentTheme={componentTheme}
        isArched={isArched}
        isAccordion={isAccordion}
        minHeight={minHeight}
        cardVerticalAlignment={cardVerticalAlignment}
        columnNumber={columnNumber}
      />
    ))}
  </Box>
);

export default MulticardList;
